import { Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '../service/layout.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-floating-configurator',
    standalone: true,
    imports: [ButtonModule, StyleClassModule, CommonModule],
    template: `
    `
})
export class AppFloatingConfigurator {
    constructor(public layoutService: LayoutService) { }

    toggleDarkMode() {
        localStorage.setItem('darkTheme', String(!this.layoutService.isDarkTheme()));
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }
}
